module.exports = __webpack_public_path__ + "static/media/galerija_2017 (22).7845e7f1.jpg";